import * as React from "react";
import * as AvatarPrimitive from "@radix-ui/react-avatar";
import { type VariantProps } from "class-variance-authority";

import { cn } from "@/lib/utils";
import {
  avatarVariants,
  avatarFallbackVariants,
  avatarImageVariants,
} from "@/lib/avatar-variants";

function Avatar({
  className,
  size,
  variant,
  shape,
  ...props
}: React.ComponentProps<typeof AvatarPrimitive.Root> &
  VariantProps<typeof avatarVariants>) {
  return (
    <AvatarPrimitive.Root
      data-slot="avatar"
      className={cn(avatarVariants({ size, variant, shape, className }))}
      {...props}
    />
  );
}

function AvatarImage({
  className,
  loaded,
  ...props
}: React.ComponentProps<typeof AvatarPrimitive.Image> &
  VariantProps<typeof avatarImageVariants>) {
  const [isLoaded, setIsLoaded] = React.useState(false);

  const handleLoad = () => {
    setIsLoaded(true);
  };

  return (
    <AvatarPrimitive.Image
      data-slot="avatar-image"
      className={cn(
        avatarImageVariants({ loaded: isLoaded || loaded }),
        className
      )}
      onLoad={handleLoad}
      {...props}
    />
  );
}

function AvatarFallback({
  className,
  size,
  ...props
}: React.ComponentProps<typeof AvatarPrimitive.Fallback> &
  VariantProps<typeof avatarFallbackVariants>) {
  return (
    <AvatarPrimitive.Fallback
      data-slot="avatar-fallback"
      className={cn(avatarFallbackVariants({ size, className }))}
      {...props}
    />
  );
}

export { Avatar, AvatarImage, AvatarFallback };
